<template>
  <CModal title="Change Photo" :show="showModal" centered :closeOnBackdrop="false" @update:show="emitShowUpdated">
    <template slot="body-wrapper" style="min-width: 800px">
      <CRow class="pl-4 pr-4 pt-4 pb-4">
        <CCol md="8">
          <div class="h5 text-gray-base mb-3">
            {{ $t('settings.profile.basicInfo.header.setPhoto') }}
          </div>
          <Cropper
            ref="crooper"
            :src="imageSrc"
            :auto-zoom="true"
            :stencil-size="getStencilSize"
            image-restriction="stencil"
            :stencil-props="{
              previewClass: 'preview',
            }"
            stencil-component="circle-stencil"
            @change="updateCropperResult"
          />
        </CCol>
        <CCol md="4">
          <div class="h5 text-gray-base mb-3">
            {{ $t('settings.profile.basicInfo.header.previewSaquare') }}
          </div>
          <div class="mb-5">
            <Preview
              style="border: 1px solid black"
              class="q-ml-md"
              :width="190"
              :height="190"
              :image="cropperResult.image"
              :coordinates="cropperResult.coordinates"
            />
          </div>
          <div class="h5 text-gray-base mb-3">
            {{ $t('settings.profile.basicInfo.header.previewRounded') }}
          </div>
          <div>
            <Preview
              style="border-radius: 60px !important; border: 1px solid black"
              class="q-ml-md"
              :width="120"
              :height="120"
              :image="cropperResult.image"
              :coordinates="cropperResult.coordinates"
            />
          </div>
        </CCol>
      </CRow>
    </template>
    <template slot="footer-wrapper">
      <div style="border-bottom: 1px solid #edeff1"></div>
      <div style="height: 50px" class="text-right pr-3 pt-2">
        <CButton color="primary" :disabled="isSaveImageBtnDisabled" @click="emitImageCropped">
          {{ $t('settings.profile.basicInfo.button.saveImage') }}
        </CButton>
      </div>
    </template>
  </CModal>
</template>

<script>
import { Cropper, Preview } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'

export default {
  components: { Cropper, Preview },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    imageSrc: {
      type: String,
      required: true,
    },
    imageName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      cropperResult: {
        image: undefined,
        coordinates: undefined,
      },
      isSaveImageBtnDisabled: false,
    }
  },
  methods: {
    updateCropperResult({ coordinates, image }) {
      this.cropperResult = {
        coordinates,
        image,
      }
    },
    emitImageCropped() {
      const { canvas } = this.$refs.crooper.getResult()

      if (canvas) {
        this.$emit('imageCropped', canvas)
      }
    },
    emitShowUpdated(value) {
      this.$emit('showUpdated', value)
    },
    getStencilSize({ boundaries }) {
      if (boundaries.height < 280) {
        return {
          width: boundaries.height * 0.5,
          height: boundaries.height * 0.5,
        }
      }
      return {
        width: 280,
        height: 280,
      }
    },
  },
}
</script>

<style>
.modal-dialog-centered {
  max-width: 800px !important;
}
</style>
